import styled from 'styled-components';

export const StyledText = styled.span`
  margin: 0.5em 0.5em 0;
  text-align: center;
`;

export const ErrorText = styled(StyledText)`
  color: #d32f2f;
  font-weight: bold;
`;
